import { queryOptions, useQuery } from '@tanstack/react-query'
import { useIntl } from 'react-intl'

import { alertApi } from '../api/alertApi'

const alertQueryOptions = (locale: TLocale) =>
  queryOptions({
    queryKey: ['alert', locale],
    queryFn: ({ signal }) => alertApi.getAlertBanner({ signal }),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  })

export const useAlertQuery = () => {
  const { locale } = useIntl()

  return useQuery(alertQueryOptions(locale))
}
